import "./Events.module.css";
import Header from "@/reusable_sections/Header";
import EventsDisplay from "./sections/EventsDisplay";
import BookingCTA from "./sections/BookingCTA";
export default function EventsPage() {
  return <div>
      <Header />
      <EventsDisplay />
      <BookingCTA />
    </div>;
}